export const getRTLPopperStyles = ({ curr, theme }) => ({
  [theme.breakpoints.up('sm')]: theme.direction === 'rtl' && {
    position: 'absolute',
    top: curr?.offsetTop,
    left: curr?.offsetLeft ? curr?.offsetLeft - theme.spacing(62) : 0
  }
});
